import { Defaults } from 'es-decorators'
import { BaseCarouselView } from './base-carousel-view'
import merge from 'lodash/merge'
import { okoPush } from 'helpers/oko-helpers'

@Defaults({
  hovered: false,
  autoplayTimeout: 3000,
  slideChangeAnimationTime: 500,
  additionalOptions: ['autoplayTimeout', 'slideChangeAnimationTime', 'eventBus'],
  events: {
    'mouseenter': 'changeHovered',
    'mouseleave': 'changeHovered',
    'change input[type=radio][name=carousel]': 'slideChange',
    'click .js-css-chponck-link': 'sendToOkoClick',
  },
})
export class CssCarouselView extends BaseCarouselView {
  /**
   * @inheritDoc
   */
  run () {
    this.autoplay(this.autoplayTimeout)
    this.listenTo(this, 'slide-change-end', this.sendDataToEventBus)
  }
  /**
   * Запуск авторотации карусели
   */
  autoplay () {
    setTimeout(this.autoPlayTimeoutCallback.bind(this), this.autoplayTimeout)
  }
  /**
   * Коллбэк для таймера авторотации
   */
  autoPlayTimeoutCallback () {
    if (!this.hovered) {
      this.next()
    }
    this.autoplay()
  }
  /**
   * Изменение состояния наведения мыши на элемент карусели
   * @param {Event} e
   */
  changeHovered (e) {
    this.hovered = e.type === 'mouseenter'
  }
  /**
   * Автоматическое переключение на следующий слайд
   */
  next () {
    const checkedInput = this.$('input:checked')
    const nextInput = checkedInput.is('input:last-of-type')
      ? this.$('input').eq(0)
      : checkedInput.next()

    if (nextInput.length) {
      nextInput.prop('checked', true).trigger('change')
    }
  }
  /**
   * @inheritDoc
   * @returns {jQuery}
   */
  getCurrentItem () {
    return this.$('.' + this.$('input:checked').attr('id')).get(0)
  }
  /**
   * Обработка события изменения слайда.
   */
  slideChange () {
    this.trigger('slide-change-start')
    setTimeout(() => {
      this.trigger('slide-change-end')
    }, this.slideChangeAnimationTime)
  }

  /**
   * Отправляем событие в око при клике на баннер
   * @param {Event} event Событие клика.
   */
  sendToOkoClick (event) {
    const parent = event.target.parentElement
    const chponkUrl = parent.getAttribute('data-chponck-url')

    okoPush(merge({
      n: 'banner-click',
      'id': parseInt(parent.getAttribute('data-chponck-id'), 10),
      'num': parseInt(parent.getAttribute('data-chponck-num'), 10),
      'url': chponkUrl ? String(chponkUrl).trim() : '',
      'place_id': parseInt(parent.getAttribute('data-chponck-place-id'), 10),
    }))
  }
}
